import React from 'react';
import PropTypes from 'prop-types';

import { Container, Form, Button, Message, Header} from 'semantic-ui-react';

const StaffPolicyVerification = props => {
    let errorMessage, tryAgainButton;
    if (props.error) {
        const content = Array.isArray(props.error) ? props.error.map((e, index) => (<div key={index}>{`${e}`}</div>)) : props.error;
        errorMessage = (<Message error content={content} />);
        //errorMessage = (<Message error header="Verification Failed" content={content} />);
    }

    if (props.allowTryAgain) {
        tryAgainButton = (<Button basic fluid type="button" onClick={props.onTryAgain}>BACK AND TRY AGAIN</Button>);
    }

    const { data } = props;       
    const emailsMatch = data.staffVerificationEmail && data.staffVerificationEmailConfirmation && data.staffVerificationEmail === data.staffVerificationEmailConfirmation;     
    const passwordsMatch = data.staffVerificationPassword && data.staffVerificationPasswordConfirmation && data.staffVerificationPassword === data.staffVerificationPasswordConfirmation;

    return (
        <Container>
            <Form onSubmit={props.onSubmit} loading={props.loading} error>
                <Header as="h1" textAlign="center" content="Having problems?" />
                {tryAgainButton}
                <Header as="h4" content="Fill in the fields below and a staff member will assist you in creating an account." />                          
                <Form.Field><input name="staffVerificationPhoneNumber" placeholder="Phone Number (xxx-xxx-xxxx)" onChange={props.onChange} type="text" /></Form.Field>
                <Form.Field inline><input name="staffVerificationEmail" placeholder="Email Address" onChange={props.onChange} type="email" /></Form.Field>
                <Form.Field inline><input name="staffVerificationEmailConfirmation" placeholder="Confirm Email Address" onChange={props.onChange} type="email" /></Form.Field>
                <Form.Field inline><input name="staffVerificationPassword" type="password" placeholder="Password" onChange={props.onChange} /></Form.Field>
                <Form.Field inline><input name="staffVerificationPasswordConfirmation" type="password" placeholder="Confirm Password" onChange={props.onChange} /></Form.Field>
                <Form.Field inline>
                    <div style={{paddingLeft: 5}}>
                    <Header as="h4" content="Password Requirements:"/>
                    <ul>
                        <li><Header as="h4" content="Must be at least 8 characters"/></li>
                        <li><Header as="h4" content="Must contain at least one digit"/></li>
                        <li><Header as="h4" content="Must contain at least one uppercase and one lowercase character"/></li>
                    </ul>
                    </div>
                </Form.Field>
                {errorMessage}                
                <Button basic fluid type="submit" disabled={!(emailsMatch && passwordsMatch)}>LET STAFF HELP ME</Button>                
            </Form>
        </Container>
    );
};

StaffPolicyVerification.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onTryAgain: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.object.isRequired,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ])
};

export default StaffPolicyVerification;